import { render, staticRenderFns } from "./EnviarAListaDeEspera.vue?vue&type=template&id=522fc266&scoped=true"
import script from "./EnviarAListaDeEspera.vue?vue&type=script&lang=js"
export * from "./EnviarAListaDeEspera.vue?vue&type=script&lang=js"
import style0 from "./EnviarAListaDeEspera.vue?vue&type=style&index=0&id=522fc266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522fc266",
  null
  
)

export default component.exports